module.exports = __webpack_public_path__ + "static/media/avatar-s-50.e67e358c.png";